/** Scope 2: purchased energy, as a table page - ADR-0212 decisions 2 and 5.
 *
 * **One number by default.** The screen this replaced always showed the location-based and the
 * market-based inventories side by side; the table now shows the location-based figure, and the
 * market-based column and tile appear when an instrument is recorded in the period or when the
 * Advanced view is on (`?method=market`). Both are calculated for every period either way, and a
 * receipt always names its method. The page is `scopeTable/ScopePage.tsx`.
 */

import { ScopeTablePage } from "./scopeTable/ScopePage";

export function Scope2Screen() {
  return <ScopeTablePage scope="2" />;
}
